function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidiAboutUscrdImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.69,188.52S592.19,73.21,431.09,34,246.27,123.15,200.47,173.8s-129.22,45-170.11,107.13,4.09,171.74,204.45,199.55,188.1-79.33,312.4-59.7S814.64,334.91,697.69,188.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.69,188.52S592.19,73.21,431.09,34,246.27,123.15,200.47,173.8s-129.22,45-170.11,107.13,4.09,171.74,204.45,199.55,188.1-79.33,312.4-59.7S814.64,334.91,697.69,188.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-172"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29.76,
    y1: 383.28,
    x2: 722.66,
    y2: 383.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.89,133.82V387.45H687.07V133.82Zm94.18,246.33H592.89v-239h86.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "610.36 163.72 603.78 163.72 600.5 187.1 613.64 187.1 610.36 163.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.4 157.29 602.74 157.29 603.74 163.91 610.4 163.91 611.4 157.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.48,
    cy: 177.21,
    r: 10.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.56,
    y: 221.26,
    width: 34.32,
    height: 35.02,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.52,
    y: 227.34,
    width: 22.4,
    height: 22.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.87,
    y: 224.09,
    width: 8.49,
    height: 31.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.71,
    y: 224.09,
    width: 8.49,
    height: 31.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.74,
    y: 224.09,
    width: 8.49,
    height: 31.84,
    transform: "translate(-34.4 122.37) rotate(-10.99)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.8,
    y: 348.22,
    width: 8.49,
    height: 31.84,
    transform: "translate(1346.08 728.28) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.95,
    y: 348.22,
    width: 8.49,
    height: 31.84,
    transform: "translate(1328.4 728.28) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.92,
    y: 348.22,
    width: 8.49,
    height: 31.84,
    transform: "translate(1222.98 845.9) rotate(-169.01)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 636.84,
    cy: 308.34,
    rx: 10.23,
    ry: 16.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.84,289c.32-2.89,2.89-14.11,2.89-14.11h-13.8s2.57,11.22,2.89,14.11a9.5,9.5,0,0,1-1.29,5.45l5.3,4.66,5.29-4.66A9.53,9.53,0,0,1,640.84,289Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.89,
    y: 187.56,
    width: 86.18,
    height: 9.31,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.89,
    y: 256.29,
    width: 86.18,
    height: 9.31,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.89,
    y: 325.01,
    width: 86.18,
    height: 9.31,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-172"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.48,
    y: 80.89,
    width: 47.8,
    height: 61.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.57,
    y: 84.86,
    width: 41.62,
    height: 53.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.66,
    y: 102.98,
    width: 13.44,
    height: 17.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 126.83,
    width: 47.8,
    height: 61.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.08,
    y: 130.8,
    width: 41.62,
    height: 53.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.18,
    y: 148.92,
    width: 13.44,
    height: 17.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 126.83,
    width: 47.8,
    height: 61.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.71,
    y: 130.8,
    width: 41.62,
    height: 53.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.81,
    y: 148.92,
    width: 13.44,
    height: 17.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.48,
    y: 152.02,
    width: 47.8,
    height: 35.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.57,
    y: 154.34,
    width: 41.62,
    height: 31.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.66,
    y: 164.92,
    width: 13.44,
    height: 10.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.21,
    y: 203.44,
    width: 30.92,
    height: 23.23,
    transform: "translate(351.72 78.38) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 204.94,
    width: 26.93,
    height: 20.23,
    transform: "translate(351.72 78.38) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.32,
    y: 211.78,
    width: 8.69,
    height: 6.53,
    transform: "translate(351.72 78.38) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.88,
    y: 203.44,
    width: 30.92,
    height: 23.23,
    transform: "translate(317.39 112.7) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 204.94,
    width: 26.93,
    height: 20.23,
    transform: "translate(317.39 112.7) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 211.78,
    width: 8.69,
    height: 6.53,
    transform: "translate(317.39 112.7) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-172"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.96,
    y: 106.51,
    width: 120.96,
    height: 166.49,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.72,
    y: 113.93,
    width: 109.43,
    height: 151.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.97,
    y1: 137.41,
    x2: 352.99,
    y2: 164.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.07,
    y1: 123.31,
    x2: 382.67,
    y2: 134.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.68,
    y1: 146.1,
    x2: 345.49,
    y2: 162.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.78,
    y1: 252.56,
    x2: 352.99,
    y2: 257.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.07,
    y1: 216.27,
    x2: 360.48,
    y2: 249.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.68,
    y1: 239.06,
    x2: 345.49,
    y2: 255.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.45,196a3.65,3.65,0,1,0-3.65,3.66A3.66,3.66,0,0,0,372.45,196Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.72,
    y: 195.44,
    width: 109.43,
    height: 6.71,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.12,
    y: 96.54,
    width: 127.36,
    height: 14.23,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.12,
    y: 268.02,
    width: 127.36,
    height: 14.23,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.58,
    y: 76.62,
    width: 217.72,
    height: 4.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.41,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.79,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.17,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.56,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.94,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.32,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.71,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.09,
    y: 73.06,
    width: 12.1,
    height: 224.84,
    rx: 4.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofa--inject-172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,316.86s1.45-41.13,6.19-42.23,17.11,2.92,56.8,1.46,60.81-.36,62.27.73,6.55,62.63,4.37,63.36-47.7-4-66.64-3.64-57.17,3.64-60.44,2.91S241,316.86,241,316.86Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.55,316.86s-1.46-41.13-6.19-42.23-17.11,2.92-56.8,1.46-60.81-.36-62.27.73-.83,62.63,1.36,63.36,42-4,60.91-3.64,57.17,3.64,60.44,2.91S494.55,316.86,494.55,316.86Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.38,
    y: 380.59,
    width: 259.98,
    height: 16.75,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.38,
    y: 336.17,
    width: 131.21,
    height: 28.91,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.12,
    y: 336.17,
    width: 128.28,
    height: 28.91,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.38,
    y: 352.56,
    width: 131.21,
    height: 28.91,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.12,
    y: 352.56,
    width: 128.28,
    height: 28.91,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,282.64s-12.39,10.19-24,10.56-16.75-2.55-23.67,1.09,12.39,44.79,18.94,47,41.51-5.83,45.51-7.28-9.1-37.51-10.92-43.33S287.05,280.82,283.05,282.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.19,295.75s-12.74-4-14.56-2.91,2.54,22.58,3.64,28.4-1.1,14.2,1.09,15.3,45.15,2.54,51,1.82-6.19-32.41-7.29-41.51-.36-8-4.73-6.56S312,295.75,302.19,295.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.92,282.64s12.38,10.19,24,10.56,16.75-2.55,23.67,1.09-12.38,44.79-18.94,47-41.51-5.83-45.51-7.28,9.1-37.51,10.92-43.33S448.91,280.82,452.92,282.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,295.75s12.75-4,14.57-2.91-2.55,22.58-3.64,28.4,1.09,14.2-1.1,15.3-45.15,2.54-51,1.82,6.19-32.41,7.28-41.51.36-8,4.73-6.56S423.94,295.75,433.77,295.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.31,311.77H240a5.09,5.09,0,0,1,5.09,5.09v87.45a4.32,4.32,0,0,1-4.32,4.32h-9.21a4.32,4.32,0,0,1-4.32-4.32V316.86A5.09,5.09,0,0,1,232.31,311.77Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498,311.77h7.66a5.09,5.09,0,0,1,5.09,5.09v87.45a4.32,4.32,0,0,1-4.32,4.32h-9.21a4.32,4.32,0,0,1-4.32-4.32V316.86A5.09,5.09,0,0,1,498,311.77Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-2--inject-172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.51,355.35c-.35-2.76-10.86-6.23-10.86-6.23l-14.37.68-14.37-.68s-10.51,3.47-10.86,6.23-6.31,43.28-6.31,43.28a103.9,103.9,0,0,0,26.63,3.81h9.82a103.9,103.9,0,0,0,26.63-3.81S578.86,358.12,578.51,355.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.28,
    cy: 346.18,
    rx: 18.02,
    ry: 6.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,332.57l6.17,8.75c0,4.31,12.59,7.8,28.11,7.8s28.11-3.49,28.11-7.8l6.17-8.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.28,
    cy: 332.57,
    rx: 34.28,
    ry: 7.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "553.35 330.76 557.98 279.22 516.67 242.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.18,242.85a5.91,5.91,0,0,0,2.59-4.34c.39-3-1.1-5.6-3.32-5.89s-4.33,1.87-4.72,4.83a5.89,5.89,0,0,0,1.38,4.86c-4.29,1-8.14,6.62-9.09,13.83a24.16,24.16,0,0,0-.21,3.25l17.95,2.35a24.18,24.18,0,0,0,.63-3.18C523.34,251.34,521.07,244.91,517.18,242.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.77,
    y: 328.25,
    width: 23.16,
    height: 5.02,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-1--inject-172"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "444.23 393.16 451.92 430.85 449.8 430.85 437.69 393.74 444.23 393.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.67 393.16 295.98 430.85 298.1 430.85 310.21 393.74 303.67 393.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.33 410.47 289.64 448.15 291.75 448.15 303.87 411.05 297.33 410.47",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.92 410.47 459.61 448.15 457.49 448.15 445.38 411.05 451.92 410.47",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.62 408.63 464.22 388.24 282.54 388.24 269.14 408.63 477.62 408.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.14,
    y: 408.63,
    width: 208.2,
    height: 3.64,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,399.46l-1.81,1.1H364.69l-1.81-1.1a43.86,43.86,0,0,0-5.91-2.82,3.45,3.45,0,0,1-2.24-4l4.12-15.83h24.5l4.12,15.83a3.45,3.45,0,0,1-2.24,4A43.86,43.86,0,0,0,379.32,399.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.51,400.56H364.69c-1.4,0-2.44-2.49-2.14-5.11l2.15-18.62h12.8l2.15,18.62C380,398.07,378.91,400.56,377.51,400.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.85 376.83 355.08 371.19 362.2 375.05 363.09 370 365.17 370.6 363.68 364.96 369.62 369.41 374.07 359.92 374.96 369.71 380.59 366.74 379.11 371.19 385.63 368.52 382.07 373.56 385.04 373.86 383.35 376.83 358.85 376.83",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.1,257.35h0a.06.06,0,0,0,0-.09.08.08,0,0,0-.1,0,94.48,94.48,0,0,0-4.91,15.4,141.23,141.23,0,0,0-2.71,16l-.39,4c-.05.67-.13,1.34-.18,2l-.11,2c0,1.35-.14,2.7-.18,4.05l0,4.06.05,2c0,.67.07,1.35.12,2,.1,1.35.18,2.7.31,4,.26,2.69.66,5.37,1.08,8a.07.07,0,0,0,.07.06.07.07,0,0,0,.07-.07h0c0-1.35-.07-2.69-.1-4s-.15-2.68-.13-4,0-2.68-.05-4l0-2,0-2,0-4,.11-4,0-2c0-.67.08-1.34.11-2l.25-4a142.53,142.53,0,0,1,2.27-15.92A93.62,93.62,0,0,1,166.1,257.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,278.37a.07.07,0,0,0-.05-.09s-.07,0-.09,0A93.66,93.66,0,0,0,162,299c-.35,3.51-.75,7-.79,10.57a87.43,87.43,0,0,0,.37,10.61.06.06,0,0,0,.06.06s.08,0,.08-.06c.41-3.52.66-7,.9-10.55s.29-7,.52-10.54a94.55,94.55,0,0,1,1.25-10.45A95.51,95.51,0,0,1,166.68,278.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33,285.76a.08.08,0,0,0-.1,0,35.26,35.26,0,0,0-7.79,6.79,31.12,31.12,0,0,0-3.05,4.23l-.62,1.19-.49,1.22a11.54,11.54,0,0,0-.43,1.25c-.12.42-.27.83-.38,1.25A50.69,50.69,0,0,0,163.86,312a58.67,58.67,0,0,0,.39,10.35.07.07,0,0,0,.14,0l.89-10.25a91.7,91.7,0,0,1,1.29-10.1c.1-.41.22-.82.32-1.23s.21-.81.36-1.2l.41-1.19.54-1.12A30,30,0,0,1,171,293a34.81,34.81,0,0,1,7.32-7.12h0A.07.07,0,0,0,178.33,285.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.69,298.92a11.34,11.34,0,0,0-3.54,4.26,25.77,25.77,0,0,0-2,5.22,12.69,12.69,0,0,0-.34,1.35l-.33,1.36a23.54,23.54,0,0,0-.34,2.77c0,.93,0,1.86,0,2.79a25.75,25.75,0,0,0,.37,2.76.09.09,0,0,0,.06.06s.07,0,.08-.06a23.93,23.93,0,0,0,.49-2.72c.15-.9.29-1.8.39-2.7s.25-1.78.32-2.68.19-1.8.39-2.67a23.8,23.8,0,0,1,1.52-5.17,11.44,11.44,0,0,1,3-4.45h0a.08.08,0,0,0,0-.1A.08.08,0,0,0,172.69,298.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,309.19c-.38-4.55-1.13-9.06-1.84-13.56s-1.5-9-2.32-13.47-1.74-8.94-2.71-13.39a.07.07,0,0,0-.08,0s-.07,0-.06.08c.78,4.49,1.48,9,2.15,13.48s1.32,9,1.89,13.51,1,9,1.56,13.54l1.66,13.54s0,.07.07.07a.07.07,0,0,0,.07-.07c.06-1.14.06-2.28.09-3.43s-.05-2.28-.07-3.42C156.72,313.73,156.52,311.46,156.35,309.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.62,309.12c-.24-1.8-.57-3.59-.92-5.38l-.63-2.65c-.21-.89-.41-1.78-.67-2.65a75.23,75.23,0,0,0-3.48-10.34l-.54-1.26-.61-1.22c-.38-.82-.85-1.61-1.29-2.4a20.22,20.22,0,0,0-3.29-4.36.07.07,0,0,0-.09,0,.07.07,0,0,0,0,.1h0a20.14,20.14,0,0,1,3,4.45c.39.81.81,1.61,1.15,2.44l.53,1.24.48,1.26a74.37,74.37,0,0,1,3,10.35c.41,1.75.69,3.53,1,5.3l.43,2.66c.15.89.34,1.77.47,2.66.28,1.78.61,3.55.92,5.33s.6,3.57,1,5.35a.07.07,0,0,0,.07.06.07.07,0,0,0,.07-.07c0-1.82,0-3.64-.13-5.45S153.81,310.93,153.62,309.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.86,309.35c-.84-2.38-1.82-4.72-2.88-7a63.59,63.59,0,0,0-3.62-6.64.1.1,0,0,0-.1,0,.08.08,0,0,0,0,.1,61.93,61.93,0,0,1,3.1,6.85c.92,2.33,1.75,4.69,2.45,7.09s1.22,4.83,1.86,7.24,1.21,4.83,2,7.27a.08.08,0,0,0,.07,0,.07.07,0,0,0,.07-.07,35.63,35.63,0,0,0-.71-7.57A46.42,46.42,0,0,0,149.86,309.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.7,317.3a16.2,16.2,0,0,0-2-4.2,17.52,17.52,0,0,0-2.91-3.62,13.31,13.31,0,0,0-1.86-1.4,7.66,7.66,0,0,0-2.1-.95.07.07,0,0,0-.08,0,.08.08,0,0,0,0,.1h0a10.51,10.51,0,0,1,3.49,2.71,16.42,16.42,0,0,1,2.43,3.68c.69,1.31,1,2.75,1.65,4.09.26.69.52,1.39.83,2.08a17.41,17.41,0,0,0,.92,2.1h0a.05.05,0,0,0,.06,0,.07.07,0,0,0,.07-.07,16.31,16.31,0,0,0-.08-2.32A22.45,22.45,0,0,0,149.7,317.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,275.29a12.94,12.94,0,0,1-9.17-9.75c-1.72-8,3.82-4.59-1.15-17.2s-3.82-15.48-2.1-19.11,2.68-2.49,4.21,2.29,7.07,12.23,9.17,26.18S150,275.29,150,275.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,261.72s-5-1.72-5.16-11.09,3.63-7.45,4.2-19.11,1.34-19.87,3.44-20.07,7.65,5.74,9.56,18.73-2.48,21.6-6.31,25.42S164.7,261.72,164.7,261.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.31,286.56s-1.15-6.88-3.44-10.13-7.26-6.11-10.51-12.42-6.88-9.36-6.69-.38,4.2,13.57,9.17,16.62S147.31,286.56,147.31,286.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21,298.41a68.89,68.89,0,0,0-11.28-15.29c-6.69-6.5-12-9.75-10.13-6.5s4.21,3.06,7.46,8.79,2.29,9.94,6.88,13.19S145.21,298.41,145.21,298.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.63,309.69c-.19-.58-.38-4.78-6.88-8.22s-12.61-2.1-11.85-.38,4.78,4.58,8.8,6.3A40.62,40.62,0,0,0,144.63,309.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.32,286.94s-2.87-3.63-1.34-11.27,5-5.74,8.79-9.75,3.06-4.59,6.88-8.79,7.26-6.5,8.79-4.78-.76,7.07-3.06,10.13-5.92,4.59-7.64,8.41-1,9.94-5.35,12.8S164.32,286.94,164.32,286.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.87,289.05s6.88-7.84,11.85-13.57,6.88-10.13,7.07-6.31,1.72,6.88-2.29,11.85S173.87,289.05,173.87,289.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,301.66s-.19-3.06,10.7-10.13,15.48-8.41,14.34-5.54-5.93,5.73-11.09,10.89S170.24,301.66,170.24,301.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,274.47s-2.56-13.71-5.23-23.46-4.4-15.67-4.4-15.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,261.86S168.9,247,170.43,238s-.19-15.67-1-19.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,286.27a72.15,72.15,0,0,0-7.05-10c-4.2-5-7.45-7.64-9.36-12.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.32,286.94s1.53-9.17,5.16-13.95,10.89-12.23,13.76-17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,309.48s-6.43-4.19-11-6.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,348c-.43-11.6-13.32-19.33-13.32-19.33H147.94S135.06,336.4,134.63,348s14.6,54.12,14.6,54.12H166.4S181.44,359.59,181,348Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.23 317.27 145.03 317.27 147.94 328.67 167.33 328.67 170.23 317.27",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidiAboutUscrdImg2);
export default __webpack_public_path__ + "static/media/AIDIAboutUscrdImg2.89265ca2b01da2b5469d666f827300ef.svg";
export { ForwardRef as ReactComponent };